var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('vs-row',[_c('vs-col',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Sync Control"}},[_c('datatable-sync-control',{ref:"datatable-sync-control"})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }